import React, { useState } from "react";
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "../../components/ui/table"; // assuming these components are available

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import formatToIndianCurrency from "../../utils/formatCurrency";

// Helper for Indian number formatting (lakh/crore)
function formatIndianNumber(num) {
  if (num === undefined || num === null) return '';
  num = Number(num);
  if (Math.abs(num) >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
  if (Math.abs(num) >= 1e5) return (num / 1e5).toFixed(2) + ' L';
  return num.toLocaleString('en-IN');
}

const MonthlyPnlTable = ({ yearWiseStrategyWiseMonthlyPnl }) => {
  const [selectedYear, setSelectedYear] = useState(
    yearWiseStrategyWiseMonthlyPnl[yearWiseStrategyWiseMonthlyPnl.length - 1]
      .year
  );

  // Get the data for the selected year
  const selectedYearData = yearWiseStrategyWiseMonthlyPnl.find(
    (item) => item.year === selectedYear
  );

  return (
    <div>
      <div className="w-full flex items-center justify-end px-3 py-2">
        <div className="grid flex-1 gap-1 text-center sm:text-left">
          <div className="text-xl font-semibold leading-none tracking-tight">
            Strategy wise Monthly PNL
          </div>
        </div>
        <div className="w-[150px]">
          <Select onValueChange={setSelectedYear} defaultValue={selectedYear}>
            <SelectTrigger>
              <SelectValue placeholder="Select Year" />
            </SelectTrigger>
            <SelectContent>
              {yearWiseStrategyWiseMonthlyPnl.map((data) => (
                <SelectItem key={data.year} value={data.year}>
                  {data.year}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="mt-4 overflow-auto custom-scroll h-[480px] ">
        <Table className="">
          <TableHeader className="bg-muted">
            <TableRow>
              <TableHead className="text-left py-4  text-[12px]">Strategy</TableHead>
              <TableHead className="text-right py-4  text-[12px]">Jan</TableHead>
              <TableHead className="text-right py-4  text-[12px]">Feb</TableHead>
              <TableHead className="text-right py-4  text-[12px]">Mar</TableHead>
              <TableHead className="text-right py-4  text-[12px]">Apr</TableHead>
              <TableHead className="text-right py-4  text-[12px]">May</TableHead>
              <TableHead className="text-right py-4  text-[12px]">Jun</TableHead>
              <TableHead className="text-right py-4  text-[12px]">Jul</TableHead>
              <TableHead className="text-right py-4  text-[12px]">Aug</TableHead>
              <TableHead className="text-right py-4  text-[12px]">Sep</TableHead>
              <TableHead className="text-right py-4  text-[12px]">Oct</TableHead>
              <TableHead className="text-right py-4  text-[12px]">Nov</TableHead>
              <TableHead className="text-right py-4  text-[12px]">Dec</TableHead>
              <TableHead className="text-right py-4  text-[12px]">Total</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {selectedYearData.pnl_data.map((strategyData) => {
              const totalPnL = strategyData.monthly_pnl.reduce(
                (acc, monthData) => acc + monthData.pnl,
                0
              );

              return (
                <TableRow key={strategyData.strategy}>
                  <TableCell className="text-left py-4">{strategyData.strategy}</TableCell>
                  {strategyData.monthly_pnl.map((monthData) => {
                    const pnlClass =
                      monthData.pnl > 0
                        ? "text-teal-400"
                        : monthData.pnl < 0
                        ? "text-rose-400"
                        : "text-white";

                    return (
                      <TableCell
                        className={`text-right py-4 ${pnlClass}`}
                        key={monthData.month}
                      >
                        {formatIndianNumber(monthData.pnl)}
                      </TableCell>
                    );
                  })}
                  <TableCell
                    className={`text-right py-4 ${
                      totalPnL > 0
                        ? "text-teal-400"
                        : totalPnL < 0
                        ? "text-rose-400"
                        : "text-white"
                    }`}
                  >
                    {Math.round(totalPnL,0)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default MonthlyPnlTable;
